import React, { Component } from 'react';
import { withContext } from '../utils/StateProvider';
import classNames from 'classnames';
import { visibleTiles } from '../utils/fogOfWar';

// The minimap shows a window of the level around the party rather than the
// whole thing, since a dungeon level is far larger than the panel. The window
// is wide enough to hold a whole town, which is shown entire.
export const WINDOW = 22;

// Top-left corner of the window, kept inside the level
function windowOrigin(position, extent) {
  return Math.max(0, Math.min(extent - WINDOW, position - Math.floor(WINDOW / 2)));
}

class MiniMap extends Component {

  render() {
    const { player_map, player_coords, explored, monsters } = this.props.context;
    // Squares in sight right now; seen-before squares are drawn dimmed
    const visible = visibleTiles(player_map, player_coords);

    const originX = windowOrigin(player_coords[0], player_map[0].length);
    const originY = windowOrigin(player_coords[1], player_map.length);
    const across = Math.min(WINDOW, player_map[0].length);
    const down = Math.min(WINDOW, player_map.length);
    const window = [];
    for (let y = originY; y < originY + down; y++) {
      window.push(player_map[y].slice(originX, originX + across).map((tile, i) => ({ tile, x: originX + i, y })));
    }

    // The grid is laid out to whatever is being shown, so the squares fill the
    // panel whether the level is 40 across or the town's 14
    const layout = {
      gridTemplateColumns: `repeat(${across}, 1fr)`,
      gridTemplateRows: `repeat(${down}, 1fr)`,
    };

    return (
        <div id="miniMap" style={layout}>
             {window.map((row)=>{
                return row.map(({ tile: column, x: ci, y: ri })=>{

                    const isPlayerHere = player_coords[0] === ci && player_coords[1] === ri;
                    if (!isPlayerHere && !explored[ri][ci]) {
                        return <div key={ri+':'+ci} className="unexplored"></div>
                    }
                    const inSight = visible.has(ci + ',' + ri);
                    // Monsters only show while the party can see them
                    const isMonsterHere = inSight && monsters.some(m => m.x === ci && m.y === ri);
                    
                    // Determine tile class based on tile type
                    let tileClass = 'grass';
                    if (column === 1 || column === 2) {
                        tileClass = 'wall';
                    } else if (column === 3 || column === 4) {
                        // Horizontal doors
                        tileClass = column === 3 ? 'door-horizontal-closed' : 'door-horizontal-open';
                    } else if (column === 5 || column === 6) {
                        // Vertical doors
                        tileClass = column === 5 ? 'door-vertical-closed' : 'door-vertical-open';
                    } else if (column === 7) {
                        // Stairs up
                        tileClass = 'stairs-tile';
                    } else if (column === 9) {
                        // Trainer's desk, or the town's training hall
                        tileClass = 'trainer-tile';
                    } else if (column === 12) {
                        tileClass = 'magic-tile';
                    } else if (column === 13) {
                        tileClass = 'market-tile';
                    } else if (column === 14) {
                        tileClass = 'temple-tile';
                    } else if (column === 15) {
                        tileClass = 'tavern-tile';
                    } else if (column === 10) {
                        // Stairs down
                        tileClass = 'stairs-down-tile';
                    } else if (column === 11) {
                        // A door that has been bashed in
                        tileClass = 'door-broken';
                    }
                    if (!inSight) {
                        tileClass = classNames(tileClass, 'remembered');
                    }
                    
                    if(isPlayerHere){
                        let player_heading = this.props.context.player_heading;
                        if(player_heading === 270){
                            player_heading = 90;
                        } else if (player_heading === 90){
                            player_heading = 270;
                        }
                        return <div key={ri+':'+ci} className={classNames(tileClass, 'player')}><img style={{rotate: player_heading +'deg'}} src="./assets/minimap_arrow.png" alt="arrow" /></div>    
                    } else if (isMonsterHere) {
                        return <div key={ri+':'+ci} className={classNames(tileClass, 'monster-tile')}></div>
                    } else if (column === 7) {
                        return <div key={ri+':'+ci} className={tileClass}>▲</div>
                    } else if (column === 10) {
                        return <div key={ri+':'+ci} className={tileClass}>▼</div>
                    } else {
                        return <div key={ri+':'+ci} className={tileClass}></div>
                    }
                 })
             })}
            
        </div>
    );
  }
}

export default withContext(MiniMap);